import { Injectable } from '@angular/core';
import { ConstantsService } from './constants.service';
import { WallConnectionService } from './wall-connection.service';
import { AppSettingsService } from './app-settings.service';
import { Floor } from '../custom/floor';
import { BuildFloorService } from './build-floor.service';

declare var THREE: any;
declare var VIGILANT: any;

@Injectable()
export class Room2DbuilderService {

  constructor(private constants: ConstantsService,
    private wallConnectionSrvc: WallConnectionService,
    private appSettings: AppSettingsService,
    private buildFloorS: BuildFloorService) { }
  buildWalls(points) {

    //     var i = 0,
    //   count = points.length,
    //   a, b,
    //   result = [],
    //   walls = [],
    //   wall;

    // for (; i < count; i++) {
    //   a = points[i];
    //   b = points[(i + 1) % count];

    //   a = new THREE.Vector3(a.x, 0, a.z);
    //   b = new THREE.Vector3(b.x, 0, b.z);

    //   wall = this.buildWall(a, b, i, a.depth);
    //   console.log("Wall ", i, " a: ", a, " b: ", b);


    //   walls.push(wall);

    //   result.push(this.createConnectionPoint(a, i));
    // }

    // this.wallConnectionSrvc.connectAllWalls(walls);

    // return walls;
  }

  buildConnectionPoints(points) {

    var i = 0,
      point,
      result = [];

    for (; i < points.length; i++) {
      point = points[i];
      point = new THREE.Vector3(point.x, 0, point.z);
      result.push(this.createConnectionPoint(point, i));
    }

    return result;
  }

  buildWall(pointA, pointB, index, width?) {

    // var size = {
    //   length: pointA.distanceTo(pointB),
    //   height: this.appSettings.getCeilingHeight(),
    //   width: width || this.constants.wallWidth
    // };


    // var angle = -Math.atan2(pointB.z - pointA.z, pointB.x - pointA.x);
    // var wall = new Wall(size, angle, index);

    // wall.position.set(pointA.x, 0, pointA.z);

    // // defaultMaterialSetter.set(wall);

    // return wall;
  }

  createConnectionPoint(point, index) {
    // var node = new VIGILANT.WallNode(index);
    // node.position.set(point.x, 0, point.z);
    // return node;
  }

  //updateWallWidth: function (wall, newWidth) {
  //    var geometry = wall.geometry,
  //        vertx = geometry.vertices;

  //    vertx[1].z = -newWidth;
  //    vertx[3].z = -newWidth;
  //    vertx[4].z = -newWidth;
  //    vertx[6].z = -newWidth;

  //    wall.userData.width = newWidth;

  //    geometry.verticesNeedUpdate = true;
  //    geometry.boundingSphere = null;
  //    geometry.boundingBox = null;
  //},

  // updateWallsHeight(walls, height) {

  //   for (var i = 0; i < walls.length; i++)
  //     walls[i].updateHeight(height);

  // }

}



// WEBPACK FOOTER //
// ./src/app/services/room2-dbuilder.service.ts